// This file is auto-generated by @hey-api/openapi-ts

import * as v from 'valibot';

export const vColorPaletteType = v.picklist([
  'CutFill',
  'Elevation',
  'PassCount',
  'CMV',
  'MDP',
  'Speed',
  'Temperature',
]);

/**
 * A single colour stop: a threshold on the data scale paired with an anchor colour.
 */
export const vColorStop = v.strictObject({
  value: v.optional(v.number()),
  color: v.optional(v.union([v.string(), v.null()])),
});

/**
 * Base Response Dto containing the result from computing a measurement
 */
export const vComputeMeasurementResponseBase = v.strictObject({});

/**
 * Service status options
 */
export const vHealthStatus = v.picklist(['Unhealthy', 'Degraded', 'Healthy']);

/**
 * Represents a link.
 */
export const vLink = v.strictObject({
  href: v.optional(v.union([v.string(), v.null()])),
});

/**
 * DTO for a line measurement's result
 */
export const vMeasurementLineResult = v.strictObject({
  length3d: v.optional(v.union([v.number(), v.null()])),
  length2d: v.optional(v.union([v.number(), v.null()])),
  verticalDifference: v.optional(v.union([v.number(), v.null()])),
  verticalAverage: v.optional(v.union([v.number(), v.null()])),
  verticalMin: v.optional(v.union([v.number(), v.null()])),
  verticalMax: v.optional(v.union([v.number(), v.null()])),
  slopeAndGradeDifference: v.optional(v.union([v.number(), v.null()])),
  slopeAndGradeMin: v.optional(v.union([v.number(), v.null()])),
  slopeAndGradeMax: v.optional(v.union([v.number(), v.null()])),
  slopeAndGradeAverage: v.optional(v.union([v.number(), v.null()])),
});

/**
 * DTO for a Polyline measurement's result
 */
export const vMeasurementPolylineResult = v.strictObject({
  length3d: v.optional(v.union([v.number(), v.null()])),
  length2d: v.optional(v.union([v.number(), v.null()])),
  verticalDifference: v.optional(v.union([v.number(), v.null()])),
  verticalAverage: v.optional(v.union([v.number(), v.null()])),
  verticalMin: v.optional(v.union([v.number(), v.null()])),
  verticalMax: v.optional(v.union([v.number(), v.null()])),
  slopeAndGradeDifference: v.optional(v.union([v.number(), v.null()])),
  slopeAndGradeMin: v.optional(v.union([v.number(), v.null()])),
  slopeAndGradeMax: v.optional(v.union([v.number(), v.null()])),
  slopeAndGradeAverage: v.optional(v.union([v.number(), v.null()])),
});

export const vMeasurementType = v.picklist([
  'Point',
  'Line',
  'Polyline',
  'Volume',
  'Area',
  'Angle',
]);

/**
 * Base DTO for creating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vComputeMeasurementBase = v.strictObject({
  type: v.optional(vMeasurementType),
});

/**
 * Base DTO for creating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vCreateMeasurementBase = v.strictObject({
  id: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  type: v.optional(vMeasurementType),
  name: v.optional(v.union([v.string(), v.null()])),
  attributes: v.optional(v.union([v.record(v.string(), v.string()), v.null()])),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
});

/**
 * DTO for creating an angle measurement.
 */
export const vCreateMeasurementAngle = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for creating an Area measurement.
 */
export const vCreateMeasurementArea = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for creating a line measurement.
 */
export const vCreateMeasurementLine = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    result: v.optional(vMeasurementLineResult),
  }),
]);

/**
 * DTO for creating a point measurement.
 */
export const vCreateMeasurementPoint = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for creating a Polyline measurement.
 */
export const vCreateMeasurementPolyline = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    result: v.optional(vMeasurementPolylineResult),
  }),
]);

/**
 * Base DTO for a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vMeasurementBase = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  tenantTrn: v.optional(v.union([v.string(), v.null()])),
  type: v.optional(vMeasurementType),
  name: v.optional(v.union([v.string(), v.null()])),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
  attributes: v.optional(v.union([v.record(v.string(), v.string()), v.null()])),
  createdBy: v.optional(v.union([v.string(), v.null()])),
  createdAt: v.optional(
    v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
  ),
  modifiedBy: v.optional(v.union([v.string(), v.null()])),
  modifiedOn: v.optional(
    v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
  ),
});

/**
 * DTO for an angle measurement.
 */
export const vMeasurementAngle = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for an Area measurement.
 */
export const vMeasurementArea = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for a line measurement.
 */
export const vMeasurementLine = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    result: v.optional(vMeasurementLineResult),
  }),
]);

/**
 * DTO for a point measurement.
 */
export const vMeasurementPoint = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for a Polyline measurement.
 */
export const vMeasurementPolyline = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    result: v.optional(vMeasurementPolylineResult),
  }),
]);

/**
 * DTO for the result of a Volume measurement.
 */
export const vMeasurementVolumeResult = v.strictObject({
  netVolume: v.optional(v.union([v.number(), v.null()])),
  totalVolume: v.optional(v.union([v.number(), v.null()])),
  totalCutVolume: v.optional(v.union([v.number(), v.null()])),
  totalFillVolume: v.optional(v.union([v.number(), v.null()])),
  totalBalanceVolume: v.optional(v.union([v.number(), v.null()])),
  totalCutArea: v.optional(v.union([v.number(), v.null()])),
  totalFillArea: v.optional(v.union([v.number(), v.null()])),
  totalCoverageArea: v.optional(v.union([v.number(), v.null()])),
  tilesetUrl: v.optional(v.union([v.string(), v.null()])),
});

/**
 * Response Dto containing the result from computing a volume measurement
 */
export const vComputeMeasurementVolumeResponse = v.intersect([
  vComputeMeasurementResponseBase,
  v.strictObject({
    result: v.optional(vMeasurementVolumeResult),
  }),
]);

/**
 * Represents a link.
 */
export const vPageLinks = v.strictObject({
  self: v.optional(vLink),
  first: v.optional(vLink),
  prev: v.optional(vLink),
  next: v.optional(vLink),
  last: v.optional(vLink),
});

/**
 * Service health
 */
export const vServiceHealth = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  status: v.optional(vHealthStatus),
  duration: v.optional(v.union([v.string(), v.null()])),
});

export const vTextureType = v.picklist(['Gradient', 'Stepped']);

/**
 * The appearance of a palette. Stop count/order, hex format, and required range colours are
 * enforced by `ColorPaletteSettingsDtoValidator`.
 */
export const vColorPaletteSettings = v.strictObject({
  textureType: v.optional(vTextureType),
  colorAboveRange: v.optional(v.union([v.string(), v.null()])),
  colorBelowRange: v.optional(v.union([v.string(), v.null()])),
  stops: v.optional(v.union([v.array(vColorStop), v.null()])),
});

/**
 * A colour palette as returned by the API. The palette-ID resolver on the tile render path
 * consumes exactly this shape, so keep it stable.
 */
export const vColorPalette = v.strictObject({
  paletteId: v.optional(v.pipe(v.string(), v.uuid())),
  tenantTrn: v.optional(v.union([v.string(), v.null()])),
  paletteType: v.optional(vColorPaletteType),
  name: v.optional(v.union([v.string(), v.null()])),
  settings: v.optional(vColorPaletteSettings),
  isDefault: v.optional(v.boolean()),
  isDeleted: v.optional(v.boolean()),
  createdBy: v.optional(v.union([v.string(), v.null()])),
  createdAt: v.optional(
    v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
  ),
  modifiedBy: v.optional(v.union([v.string(), v.null()])),
  modifiedOn: v.optional(
    v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
  ),
});

/**
 * Request body to create a palette. The owning project (tenant) comes from the route/auth context,
 * not the body.
 */
export const vCreateColorPalette = v.strictObject({
  paletteType: v.optional(vColorPaletteType),
  name: v.optional(v.union([v.string(), v.null()])),
  settings: v.optional(vColorPaletteSettings),
  isDefault: v.optional(v.boolean()),
});

/**
 * Represents a paged list.
 */
export const vPagedListColorPalette = v.strictObject({
  pageIndex: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  totalItems: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(v.union([v.array(vColorPalette), v.null()])),
  links: v.optional(vPageLinks),
});

/**
 * Request body to update a palette. All fields are optional; `PaletteType` is immutable after
 * create and is therefore not present here.
 */
export const vUpdateColorPalette = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  settings: v.optional(vColorPaletteSettings),
  isDefault: v.optional(v.union([v.boolean(), v.null()])),
});

/**
 * Base DTO for updating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vUpdateMeasurementBase = v.strictObject({
  type: v.optional(vMeasurementType),
  name: v.optional(v.union([v.string(), v.null()])),
  attributes: v.optional(v.union([v.record(v.string(), v.string()), v.null()])),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
});

/**
 * DTO for updating an angle measurement.
 */
export const vUpdateMeasurementAngle = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for updating an Area measurement.
 */
export const vUpdateMeasurementArea = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for creating a line measurement.
 */
export const vUpdateMeasurementLine = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    result: v.optional(vMeasurementLineResult),
  }),
]);

/**
 * DTO for creating a point measurement.
 */
export const vUpdateMeasurementPoint = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
  }),
]);

/**
 * DTO for updating a Polyline measurement.
 */
export const vUpdateMeasurementPolyline = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    result: v.optional(vMeasurementPolylineResult),
  }),
]);

export const vVolumeType = v.picklist(['SurfaceToSurface']);

/**
 * DTO for the parameters used for calculating a Volume measurement.
 */
export const vMeasurementVolumeParameters = v.strictObject({
  volumeType: v.optional(vVolumeType),
  fromSurfaceId: v.optional(v.union([v.string(), v.null()])),
  fromSurfaceName: v.optional(v.union([v.string(), v.null()])),
  toSurfaceId: v.optional(v.union([v.string(), v.null()])),
  toSurfaceName: v.optional(v.union([v.string(), v.null()])),
  fromFilterId: v.optional(v.union([v.string(), v.null()])),
  fromFilterName: v.optional(v.union([v.string(), v.null()])),
  toFilterId: v.optional(v.union([v.string(), v.null()])),
  toFilterName: v.optional(v.union([v.string(), v.null()])),
  accountUid: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  projectUid: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  boundaryInclusive: v.optional(
    v.union([v.record(v.string(), v.unknown()), v.null()])
  ),
  includeTilesetUrl: v.optional(v.union([v.boolean(), v.null()])),
});

/**
 * Dto to compute a volume measurement
 */
export const vComputeMeasurementVolume = v.intersect([
  vComputeMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementVolumeParameters),
  }),
]);

/**
 * DTO for creating a Volume measurement.
 */
export const vCreateMeasurementVolume = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementVolumeParameters),
    result: v.optional(vMeasurementVolumeResult),
  }),
]);

/**
 * DTO for a Volume measurement.
 */
export const vMeasurementVolume = v.intersect([
  vMeasurementBase,
  v.strictObject({
    parameters: v.optional(vMeasurementVolumeParameters),
    result: v.optional(vMeasurementVolumeResult),
  }),
]);

/**
 * Represents a paged list.
 */
export const vPagedListMeasurementBase = v.strictObject({
  pageIndex: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  totalItems: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(v.union([v.array(v.unknown()), v.null()])),
  links: v.optional(vPageLinks),
});

/**
 * DTO for updating a Volume measurement.
 */
export const vUpdateMeasurementVolume = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementVolumeParameters),
    result: v.optional(vMeasurementVolumeResult),
  }),
]);

export const vListColorPalettesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tenantTrn: v.string(),
  }),
  query: v.optional(
    v.object({
      PaletteType: v.optional(vColorPaletteType),
      PageIndex: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
      PageSize: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
      SortBy: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vListColorPalettesResponse = vPagedListColorPalette;

export const vCreateColorPaletteData = v.object({
  body: v.optional(vCreateColorPalette),
  path: v.object({
    tenantTrn: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * Created
 */
export const vCreateColorPaletteResponse = vColorPalette;

export const vGetDefaultColorPaletteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tenantTrn: v.string(),
  }),
  query: v.optional(
    v.object({
      PaletteType: v.optional(vColorPaletteType),
    })
  ),
});

/**
 * OK
 */
export const vGetDefaultColorPaletteResponse = vColorPalette;

export const vDeleteColorPaletteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tenantTrn: v.string(),
    id: v.pipe(v.string(), v.uuid()),
  }),
  query: v.optional(v.never()),
});

/**
 * No Content
 */
export const vDeleteColorPaletteResponse = v.void();

export const vGetColorPaletteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tenantTrn: v.string(),
    id: v.pipe(v.string(), v.uuid()),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vGetColorPaletteResponse = vColorPalette;

export const vUpdateColorPaletteData = v.object({
  body: v.optional(vUpdateColorPalette),
  path: v.object({
    tenantTrn: v.string(),
    id: v.pipe(v.string(), v.uuid()),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vUpdateColorPaletteResponse = vColorPalette;

export const vCheckHealthData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    region: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vCheckHealthResponse = v.array(vServiceHealth);

export const vListMeasurementsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tenantTrn: v.string(),
  }),
  query: v.optional(
    v.object({
      PageIndex: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
      PageSize: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
      SortBy: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vListMeasurementsResponse = vPagedListMeasurementBase;

export const vCreateMeasurementData = v.object({
  body: v.optional(
    v.union([
      vCreateMeasurementVolume,
      vCreateMeasurementPolyline,
      vCreateMeasurementPoint,
      vCreateMeasurementLine,
      vCreateMeasurementArea,
      vCreateMeasurementAngle,
    ])
  ),
  path: v.object({
    tenantTrn: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * Base DTO for a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vCreateMeasurementResponse = v.union([
  vMeasurementVolume,
  vMeasurementPolyline,
  vMeasurementPoint,
  vMeasurementLine,
  vMeasurementArea,
  vMeasurementAngle,
]);

export const vComputeMeasurementData = v.object({
  body: v.optional(vComputeMeasurementVolume),
  path: v.object({
    tenantTrn: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * Base Response Dto containing the result from computing a measurement
 */
export const vComputeMeasurementResponse = vComputeMeasurementVolumeResponse;

export const vDeleteMeasurementData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tenantTrn: v.string(),
    measurementId: v.pipe(v.string(), v.uuid()),
  }),
  query: v.optional(v.never()),
});

/**
 * No Content
 */
export const vDeleteMeasurementResponse = v.void();

export const vGetMeasurementData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tenantTrn: v.string(),
    measurementId: v.pipe(v.string(), v.uuid()),
  }),
  query: v.optional(v.never()),
});

/**
 * Base DTO for a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vGetMeasurementResponse = v.union([
  vMeasurementVolume,
  vMeasurementPolyline,
  vMeasurementPoint,
  vMeasurementLine,
  vMeasurementArea,
  vMeasurementAngle,
]);

export const vUpdateMeasurementData = v.object({
  body: v.optional(
    v.union([
      vUpdateMeasurementVolume,
      vUpdateMeasurementPolyline,
      vUpdateMeasurementPoint,
      vUpdateMeasurementLine,
      vUpdateMeasurementArea,
      vUpdateMeasurementAngle,
    ])
  ),
  path: v.object({
    tenantTrn: v.string(),
    measurementId: v.pipe(v.string(), v.uuid()),
  }),
  query: v.optional(v.never()),
});

/**
 * Base DTO for a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vUpdateMeasurementResponse = v.union([
  vMeasurementVolume,
  vMeasurementPolyline,
  vMeasurementPoint,
  vMeasurementLine,
  vMeasurementArea,
  vMeasurementAngle,
]);
